<template>
    <main class="page" role="main">
        <div class="o-wrapper">
            <div class="o-grid--center u-m-t4 u-width-5/8 u-width-10/12@l u-width-full@m u-center">
                <h1>{{ code }} Error</h1>
                <p class="u-m-t2">{{ reason }}</p>
                <p class="u-text-meta">Error page: {{ from }}</p>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    data() {
        return {
            code: null,
            reason: null,
            from: null
        }
    },
    created() {
        this.code = this.$route.query.code;
        this.reason = this.$route.query.reason;
        this.from = this.$route.query.from;
    },
    methods: {

    }
}
</script>
